export default __webpack_public_path__ + "static/media/web.8069cae2.png";